import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { REDUCERS } from '../reducers';

const enhancer = composeWithDevTools(applyMiddleware(thunk));
export const store = createStore(combineReducers(REDUCERS), enhancer);
